import { atom, getDefaultStore } from "jotai";

const STORAGE_KEY = "locale";

const store = getDefaultStore();

// undefined means "use whatever the browser is configured for".
export const localeAtom = atom<string | undefined>(sessionStorage.getItem(STORAGE_KEY) ?? undefined);

const get = () => store.get(localeAtom);

const set = (locale: string | undefined) =>
{
	if (locale)
	{
		sessionStorage.setItem(STORAGE_KEY, locale);
	}
	else
	{
		sessionStorage.removeItem(STORAGE_KEY);
	}

	store.set(localeAtom, locale);
};

export const localeStore = {
	get,
	set,
};
